import { render } from "./BaseInputError.vue?vue&type=template&id=7ef2e15e"
import script from "./BaseInputError.vue?vue&type=script&lang=js"
export * from "./BaseInputError.vue?vue&type=script&lang=js"
script.render = render

export default script